/**
 * Configurazione del sito: dati non segreti e uguali in ogni ambiente, da personalizzare per ogni cliente.
 * La leggono frontend (SEO, header, footer, dati strutturati) e backend (chatbot, email).
 * I testi traducibili (claim, SEO, etichette) stanno nei locales: apps/frontend/src/i18n/locales/{it,en}/common.json.
 * Secret e valori che cambiano per ambiente (SITE_URL, MAIL_PROVIDER, chiavi API…) stanno in .env.local
 * (vedi .env.example) e, su Cloudflare, in wrangler.jsonc / `wrangler secret put`.
 * Campi vuoti: omessi da footer, contatti e dati strutturati, mai mostrati vuoti.
 */
export type SiteConfig = {
  /** Nome del brand: title delle pagine, WebSite/Organization, header, footer, chatbot ed email. */
  name: string
  /** Nome alternativo (sigla, ragione sociale breve): WebSite.alternateName. */
  alternateName: string
  /** Ragione sociale: footer e Organization.legalName. */
  legalName: string
  /** Partita IVA: footer e Organization.vatID. */
  vatId: string
  /** Dominio del vecchio sito del cliente (es. `sepma.eu`): lo leggono le skill sepma di audit e migrazione. */
  oldUrl: string
  /** Percorsi in apps/frontend/public/. */
  logo: string
  ogImage: string
  contact: {
    /** Email pubblica: footer, Organization e indirizzo di contatto nel footer delle email (obbligatoria per inviarle). */
    email: string
    phone: string
    address: { street: string; city: string; postalCode: string; region: string; country: string }
  }
  /** URL dei profili social: Organization.sameAs e link nel footer. */
  social: string[]
  mail: {
    /** Mittente delle email (un indirizzo noreply del dominio): form contatti, inviti, reset password. */
    from: string
  }
  /** Prompt di sistema e modelli OpenRouter del chatbot. */
  chatbot: {
    /** Cosa fa l'azienda, in una frase: "You are the virtual assistant of <name>, <description>." */
    description: string
    /** Argomenti a cui il chatbot risponde (gli altri li rifiuta). */
    topics: string
    embeddingModel: string
    llmModel: string
  }
}

export const site: SiteConfig = {
  name: 'SEPMA',
  alternateName: 'Sepma',
  legalName: '',
  vatId: '',
  oldUrl: 'sepma.eu',
  logo: '/media/logos/sepma.png',
  ogImage: '/media/og-image.png',
  contact: {
    email: 'info@sepma.eu',
    phone: '',
    address: { street: '', city: '', postalCode: '', region: '', country: 'IT' },
  },
  social: [],
  mail: {
    from: 'noreply@sepma.eu',
  },
  chatbot: {
    description:
      'uno studio tech con anima artigiana specializzato in sviluppo web, aree riservate, gestionali su misura, identità digitale, SEO, chatbot e automazioni per professionisti e aziende che vogliono crescere online',
    topics:
      'Siti Web & Brochure, Aree Riservate & Gestionali, Identità Digitale, SEO & Performance, Chatbot & Automazioni, Segreteria Digitale, Preventivi e contatti',
    embeddingModel: 'openai/text-embedding-3-small',
    llmModel: 'openai/gpt-5-nano',
  },
}
